import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { GraphqlService, IResposne } from 'src/app/services/graphql.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FolderService {

  public name: string
  public folder

  public folders = [
    {
      name: "home",
      functionMutation: "",
      functionQuery: "",
      folders: [],
      route: ""
    },
    {
      name: "policies",
      folders: [],
      functionMutation: "createPolicyFolder",
      functionQuery: "policyFolders",
      functionQueryItems: {
        name: "policyFolder",
        queryParams: "id,name,policies{id,documentTitle,revisionNumber,signed,signedText,text},uploadedPolicies{id,fileName,dateUploaded,uploadedPolicyUrl}"
      },
      deleteFunction: "deletePolicyFolder",
      route: "/ihss/ohssystem/policies/policies-main"
    },
    {
      name: "baseline",
      functionMutation: "createBaselineRiskAssessmentFolder",
      functionQuery: "baselineRiskAssessmentFolders",
      folders: [],
      functionQueryItems: {
        name: "baselineRiskAssessmentFolder",
        queryParams: "id, name, baselineRiskAssessments{id,creationDate,revisionDate,revisionNumber,documentTitle,section,locked,folderId,requirements{documentationRequired,trainingRequired,ppeRequired,personsInvolved},processes{taskProcess,hazards,risks,preventativeMeasure,riskRatingP,riskRatingS,riskRatingF,controlMeasure,residualRiskP,residualRiskS,residualRiskF,score,action}},uploadedBaselineRiskAssessments{id,fileName,dateUploaded,uploadedBaselineRiskAssessmentUrl}"
      },
      deleteFunction: "deleteBaselineRiskAssessmentFolder",
      route: "/ihss/ohssystem/riskassessments/baseline/baseline-main"
    },
    {
      name: "taskissue",
      functionMutation: "createTaskRiskAssessmentFolder",
      functionQuery: "taskRiskAssessmentFolders",
      folders: [],
      functionQueryItems: {
        name: "taskRiskAssessmentFolder",
        queryParams: "id, name, taskRiskAssessments{id,creationDate,revisionDate,revisionNumber,documentTitle,section,locked,folderId,location,assessedBy,hseEmpRepresent,activityDesc,workConditions,requirements{documentationRequired,trainingRequired,ppeRequired,personsInvolved,emergencySituation,sops,legislationCode,inspection,action,existingControls,standards,guidanceMaterial,incidentInvestigation,nearHits},processes{taskProcess,hazards,risks,preventativeMeasure,riskRatingP,riskRatingS,riskRatingF,controlMeasure,residualRiskP,residualRiskS,residualRiskF,score,action}},uploadedTaskRiskAssessments{id,fileName,dateUploaded,uploadedTaskRiskAssessmentUrl}"
      },
      deleteFunction: "deleteTaskRiskAssessmentFolder",
      route: "/ihss/ohssystem/riskassessments/task-issue/task-issue-main"
    },
    {
      name: "dsti",
      functionMutation: "createDstiRiskAssessmentFolder",
      functionQuery: "dstiRiskAssessmentFolders",
      folders: [],
      functionQueryItems: {
        name: "dstiRiskAssessmentFolder",
        queryParams: "id,name,dstiRiskAssessments{id,creationDate,documentTitle,section,folderId,company,area,supervisor,referingNumbers,listOfTasks,listOfHazards,listOfPrecautions,lineItems{description,toStandard,correctiveMeasures,date}},uploadedDstiRiskAssessments{id,fileName,dateUploaded,uploadedDstiRiskAssessmentUrl}"
      },
      deleteFunction: "deleteDstiRiskAssessmentFolder",
      route: "/ihss/ohssystem/riskassessments/dsti/dsti-main"
    },
    {
      name: "appointmentletters",
      functionMutation: "createAppointmentLetterFolder",
      functionQuery: "appointmentLetterFolders",
      folders: [],
      functionQueryItems: {
        name: "appointmentLetterFolder",
        queryParams: "id,name,appointmentLetters{id,creationDate,revisionDate,revisionNumber,signed,signedText,documentTitle,section,text,folderId,employee},uploadedAppointmentLetters{id,fileName,dateUploaded,uploadedAppointmentLetterUrl}"
      },
      deleteFunction: "deleteAppointmentLetterFolder",
      route: "/ihss/ohssystem/appointmentletters/appointmentletters-main"
    },
    {
      name: "Drawings",
      functionMutation: "createEmergencyPrepDrawingsFolder",
      functionQuery: "emergencyPrepDrawingsFolders",
      folders: [],
      functionQueryItems: {
        name: "emergencyPrepFolder",
        queryParams: "id,name,type,uploadedEmergencyPreps{id,fileName,dateUploaded,uploadedEmergencyPrepUrl,folderId}"
      },
      deleteFunction: "deleteEmergencyPrepFolder",
      route: "/ihss/ohssystem/emergency/drawings"
    },
    {
      name: "EPP",
      functionMutation: "createEmergencyPrepEppFolder",
      functionQuery: "emergencyPrepEppFolders",
      folders: [],
      functionQueryItems: {
        name: "emergencyPrepFolder",
        queryParams: "id,name,type,uploadedEmergencyPreps{id,fileName,dateUploaded,uploadedEmergencyPrepUrl,folderId}"
      },
      deleteFunction: "deleteEmergencyPrepFolder",
      route: "/ihss/ohssystem/emergency/epp"
    },
    {
      name: "nearmiss",
      functionMutation: "createNearMissIncidentFolder",
      functionQuery: "nearMissIncidentFolders",
      folders: [],
      functionQueryItems: {
        name: "nearMissIncidentFolder",
        queryParams: "id,name,nearMissIncidents{id,creationDate,incidentDate,location,department,folderId,whatHappened,correctiveAction},uploadedNearMissIncidents{id,fileName,dateUploaded,uploadedNearMissIncidentUrl}"
      },
      deleteFunction: "deleteNearMissIncidentFolder",
      route: "/ihss/ohssystem/incidentmanager/nearmiss"
    },
    {
      name: "minor",
      functionMutation: "createMinorIncidentFolder",
      functionQuery: "minorIncidentFolders",
      folders: [],
      functionQueryItems: {
        name: "minorIncidentFolder",
        queryParams: "id,name,minorIncidents{id,creationDate,incidentDate,location,department,folderId,nameSurname,personId,details,firstAidGiven},uploadedMinorIncidents{id,fileName,dateUploaded,uploadedMinorIncidentUrl}"
      },
      deleteFunction: "deleteMinorIncidentFolder",
      route: "/ihss/ohssystem/incidentmanager/minor"
    },
    {
      name: "major",
      functionMutation: "createMajorIncidentFolder",
      functionQuery: "majorIncidentFolders",
      folders: [],
      functionQueryItems: {
        name: "majorIncidentFolder",
        queryParams: "id,name,majorIncidents{id,creationDate,incidentDate,location,department,folderId,investigatorsName,incidentNumber,signedOff,reportedDol,witnessStatements{witnessName,witnessIdNumber,witnessDesignation,dateWitnessed,dateOfStatement,statement},record{dateOfIncident,personInvolved,classification,division,positionHeld,yearsOfService,periodInPresentPos,lineManager,lineManager1,areaOhsRep,bodyPartAffected{neck,head,eye,ear,finger,hand,arm,foot,leg,face,chest,back,abdomen,internal,multipleBodyParts,respiratorySystem,nervousSystem,otherBodyPartAffected},injurySustained{sprain,strain,laceration,fracture,burns,amputation,electricShock,asphyxiation,unconscious,poisoning,multipleInjuries,abrasion,puncture,bruise,dislocation,inhalation,otherInjurySustained},descriptionOfInjury,damage{description,repairCost}},investigation{investigatorName,investigatorDesignation,plantArea,incidentCauses{humanError{unauthorizedUse,unsafeSpeed,safetyDevicesNotUsed,usingUnsafeEquipment,unsafeUseOfEquipment,unsafeProcedures,unsafePositionTaken,distraction,ppeNotUsed,safetyProceduresIgnored,otherHumanError},personalFactors{unskilled,inexperienced,negativeAttitude,unmotivated,otherPersonalFactors},workConditions{directUse,ppeFailure,faultyEquipment,inappropriateConditions,poorDesign,inadequateLighting,unsafeFloorConditions,incorrectClothing,poorVentilation,heatOrColdFactor,otherWorkConditions},jobFactors{workConditions,unsafeConditions}},preventiveActions{personalRequirements{completeTrainingCourse,followWrittenWorkProcedures,undergoMedicalExamination,transferToAnotherPosition,writtenWarning},jobRequirements{compileWrittenSafeWorkProcedure,assessWorkProcedures,repairEquipmentMachinery,upgradeInstallSafetyGuards,modifyEquipmentMachinery,lockOut,housekeeping},otherPreventiveActions{reenigneeringRedesign,otherPreventiveActions}},incidentSummary},preventativeActionAndCostAnalysis{preventativeAction{actionPlans{actionPlan,taskedTo,date},investigator,investigatorSignature,investigatorSigned,investigatorDateSigned,ohsChairperson,ohsChairpersonSignature,ohsChairpersonSigned,ohsChairpersonDateSigned,ohsOfficer,ohsOfficerSignature,ohsOfficerSigned,ohsOfficerDateSigned},costAnalysis{firstAidHours,firstAidPh,investigationHours,investigationPh,witnessWagePersons,witnessWageHours,witnessWagePhPerson,witnessSalaryPersons,witnessSalaryHours,witnessSalaryPhPerson,personHours,personPhPerson,overtimeDamage,overtimeReplacement,labourRepairPersons,labourRepairHours,labourRepairPhPerson,ambulanceHospital,ambulanceDoctor,recoveredMedicalInsurance,otherRecoveredMedical}},photoUploads{fileName,dateUploaded,majorIncidentPhotoUrl},wclFormUploads{fileName,wclFormType,dateUploaded,majorIncidentWclFormUrl}},uploadedMajorIncidents{id,fileName,dateUploaded,uploadedMajorIncidentUrl}"
      },
      deleteFunction: "deleteMajorIncidentFolder",
      route: "/ihss/ohssystem/incidentmanager/major"
    },
    {
      name: "fatality",
      functionMutation: "createFatalityIncidentFolder",
      functionQuery: "fatalityIncidentFolders",
      folders: [],
      functionQueryItems: {
        name: "fatalityIncidentFolder",
        queryParams: "fatalityIncidents{id,creationDate,incidentDate,location,department,folderId,investigatorsName,incidentNumber,signedOff,reportedDol,witnessStatements{witnessName,witnessIdNumber,witnessDesignation,dateWitnessed,dateOfStatement,statement},record{dateOfIncident,personInvolved,classification,division,positionHeld,yearsOfService,periodInPresentPos,lineManager,lineManager1,areaOhsRep,bodyPartAffected{neck,head,eye,ear,finger,hand,arm,foot,leg,face,chest,back,abdomen,internal,multipleBodyParts,respiratorySystem,nervousSystem,otherBodyPartAffected},injurySustained{sprain,strain,laceration,fracture,burns,amputation,electricShock,asphyxiation,unconscious,poisoning,multipleInjuries,abrasion,puncture,bruise,dislocation,inhalation,otherInjurySustained},descriptionOfInjury,damage{description,repairCost}},investigation{investigatorName,investigatorDesignation,plantArea,incidentCauses{humanError{unauthorizedUse,unsafeSpeed,safetyDevicesNotUsed,usingUnsafeEquipment,unsafeUseOfEquipment,unsafeProcedures,unsafePositionTaken,distraction,ppeNotUsed,safetyProceduresIgnored,otherHumanError},personalFactors{unskilled,inexperienced,negativeAttitude,unmotivated,otherPersonalFactors},workConditions{directUse,ppeFailure,faultyEquipment,inappropriateConditions,poorDesign,inadequateLighting,unsafeFloorConditions,incorrectClothing,poorVentilation,heatOrColdFactor,otherWorkConditions},jobFactors{workConditions,unsafeConditions}},preventiveActions{personalRequirements{completeTrainingCourse,followWrittenWorkProcedures,undergoMedicalExamination,transferToAnotherPosition,writtenWarning},jobRequirements{compileWrittenSafeWorkProcedure,assessWorkProcedures,repairEquipmentMachinery,upgradeInstallSafetyGuards,modifyEquipmentMachinery,lockOut,housekeeping},otherPreventiveActions{reenigneeringRedesign,otherPreventiveActions}},incidentSummary},preventativeActionAndCostAnalysis{preventativeAction{actionPlans{actionPlan,taskedTo,date},investigator,investigatorSignature,investigatorSigned,investigatorDateSigned,ohsChairperson,ohsChairpersonSignature,ohsChairpersonSigned,ohsChairpersonDateSigned,ohsOfficer,ohsOfficerSignature,ohsOfficerSigned,ohsOfficerDateSigned},costAnalysis{firstAidHours,firstAidPh,investigationHours,investigationPh,witnessWagePersons,witnessWageHours,witnessWagePhPerson,witnessSalaryPersons,witnessSalaryHours,witnessSalaryPhPerson,personHours,personPhPerson,overtimeDamage,overtimeReplacement,labourRepairPersons,labourRepairHours,labourRepairPhPerson,ambulanceHospital,ambulanceDoctor,recoveredMedicalInsurance,otherRecoveredMedical}},photoUploads{fileName,dateUploaded,fatalityIncidentPhotoUrl}},uploadedFatalityIncidents{id,fileName,dateUploaded,uploadedFatalityIncidentUrl}"
      },
      deleteFunction: "deleteFatalityIncidentFolder",
      route: "/ihss/ohssystem/incidentmanager/fatality"
    },
    {
      name: "security",
      functionMutation: "createSecurityIncidentFolder",
      functionQuery: "securityIncidentFolders",
      folders: [],
      functionQueryItems: {
        name: "securityIncidentFolder",
        queryParams: "id,name,securityIncidents{id,creationDate,incidentDate,location,department,folderId,employeeName,employeeNumber,positionTitle,companyPhone,companyEmail,incidentInformation{reportedOn,supervisor,jobSite,specificLocation},equipmentInformation{listOfEquipment,equipmentId,equipmentLocation,damageHowWas,damageDescription,repairCostEstimate,personResponsible,reportedToPolice},policeReport{policeFile,officerInCharge,stationNumber,phoneNumber,email}},uploadedSecurityIncidents{id,fileName,dateUploaded,uploadedSecurityIncidentUrl}"
      },
      deleteFunction: "deleteSecurityIncidentFolder",
      route: "/ihss/ohssystem/incidentmanager/security"
    },
    {
      name: "msdsregister",
      functionMutation: "createMsdsDocumentFolder",
      functionQuery: "msdsDocumentFolders",
      folders: [],
      functionQueryItems: {
        name: "msdsDocumentFolder",
        queryParams: "id,name,uploadedMsdsDocuments{id,fileName,dateUploaded,uploadedMsdsDocumentUrl,folderId}"
      },
      deleteFunction: "deleteMsdsDocumentFolder",
      route: "/ihss/ohssystem/hazardoussubstances/msdsregister"
    },
    {
      name: "recordofdisposal",
      functionMutation: "createDisposalRecordFolder",
      functionQuery: "disposalRecordFolders",
      folders: [],
      functionQueryItems: {
        name: "disposalRecordFolder",
        queryParams: "id,name,disposalRecords{id,documentTitle,section,creationDate,disposerName,disposerAddress,contactDetails,contactPerson,contactEmail,companyRegistrationNumber,beeCertificate,physicalAddress,folderId}"
      },
      deleteFunction: "deleteDisposalRecordFolder",
      route: "/ihss/ohssystem/hazardoussubstances/record-disposal"
    },
    {
      name: "Task Manager",
      functionMutation: "createTaskRiskAssessmentFolder",
      functionQuery: "taskRiskAssessmentFolders",
      folders: [],
      functionQueryItems: {
        name: "taskRiskAssessmentFolder",
        queryParams: "id,creationDate,revisionDate,revisionNumber,documentTitle,section,locked,folderId,location,assessedBy,hseEmpRepresent,activityDesc,workConditions,requirements{documentationRequired,trainingRequired,ppeRequired,personsInvolved,emergencySituation,sops,legislationCode,inspection,action,existingControls,standards,guidanceMaterial,incidentInvestigation,nearHits},processes{taskProcess,hazards,risks,preventativeMeasure,riskRatingP,riskRatingS,riskRatingF,controlMeasure,residualRiskP,residualRiskS,residualRiskF,score,action}"
      },
      deleteFunction: "deleteTaskRiskAssessmentFolder",
      route: "/ihss/taskmanager/taskmanager-main"
    },
    {
      name: "vendormanagement",
      functionMutation: "createVendorFolder",
      functionQuery: "vendorFolders",
      folders: [],
      functionQueryItems: {
        name: "vendorFolder",
        queryParams: "id,name,vendor{id,creationDate,vendorName,contactDetails,scopeOfWork,revisionNumber,numberOfEmployees,contactPerson,contactEmail,companyRegNumber,bee,physicalAddress,city,province,country,vendorApproved}"
      },
      route: "/ihss/ohssystem/vendormanagement/vendor-main",
      deleteFunction: "deleteVendorFolder"
    },
    {
      name: "company",
      functionMutation: "createCompanyFolder",
      functionQuery: "companyFolders",
      folders: [],
      functionQueryItems: {
        name: "companyFolder",
        queryParams: "id,name,uploadedCompanys{id,fileName,dateUploaded,uploadedCompanyUrl,folderId}"
      },
      deleteFunction: "deleteCompanyFolder",
      route: "/ihss/companydocs/company-main"
    },
    {
      name: "legislation",
      functionMutation: "createLegislationFolder",
      functionQuery: "legislationFolders",
      folders: [],
      functionQueryItems: {
        name: "legislationFolder",
        queryParams: "id,name,uploadedLegislations{id,fileName,dateUploaded,uploadedLegislationUrl,folderId}"
      },
      deleteFunction: "deleteLegislationFolder",
      route: "/ihss/ohssystem/legislation/legislation-main"
    },
    {
      name: "trainingmatrix",
      functionMutation: "createTrainingFolder",
      functionQuery: "trainingFolders",
      folders: [],
      functionQueryItems: {
        name: "trainingFolder",
        queryParams: "trainingItem{id,name}"
      },
      deleteFunction: "deleteTrainingFolder",
      route: "/ihss/ohssystem/trainingmatrix/training"
    },
    {
      name: "attendanceregister",
      functionMutation: "createAttendanceFolder",
      functionQuery: "attendanceFolders",
      folders: [],
      functionQueryItems: {
        name: "attendanceFolder",
        queryParams: "attendanceItem{id,presenter}"
      },
      deleteFunction: "deleteAttendanceFolder",
      route: "/ihss/ohssystem/trainingmatrix/attendanceregister"
    },
    {
      name: "toolboxtalk",
      functionMutation: "createToolboxFolder",
      functionQuery: "toolboxFolders",
      folders: [],
      functionQueryItems: {
        name: "toolboxFolder",
        queryParams: "id,name,toolboxes{id,documentTitle,revisionNumber,signed,signedText,text},uploadedToolboxes{id,fileName,dateUploaded,uploadedToolboxUrl}"
      },
      deleteFunction: "deleteToolboxFolder",
      route: "/ihss/ohssystem/trainingmatrix/toolbox"
    },
    {
      name: "internalaudit",
      functionMutation: "createAuditFolder",
      functionQuery: "auditFolders",
      folders: [],
      functionQueryItems: {
        name: "auditFolder",
        queryParams: "id,name,audit{id,creationDate,name,department,description,status,date}"
      },
      deleteFunction: "deleteAuditFolder",
      route: "/ihss/ohssystem/complianceaudits/compliance-main"
    },
    {
      name: "ppe",
      functionMutation: "createPpeFolder",
      functionQuery: "ppeFolders",
      folders: [],
      functionQueryItems: {
        name: "ppeFolder",
        queryParams: "ppeItems{id,creationDate,name,onepiece,twopiece,safetyshoe,pvc,gloves,mask,respirator,goggles,earmuffs,harness,hardhat,reflector,jacket,signature}"
      },
      deleteFunction: "deletePpeFolder",
      route: "/ihss/ohssystem/personalprotection/personalprotection-main"
    },
    {
      name: "employeeregister",
      functionMutation: "createEmployeeFolder",
      functionQuery: "employeeFolders",
      folders: [],
      functionQueryItems: {
        name: "employeeFolder",
        queryParams: "id,name,employees{id, firstName,surname}"
      },
      deleteFunction: "deleteEmployeeFolder",
      route: "/ihss/ohssystem/employeeregister/employeeregister-main"
    },
    {
      name: "procedures",
      functionMutation: "createProcedureFolder",
      functionQuery: "procedureFolders",
      folders: [],
      functionQueryItems: {
        name: "procedureFolder",
        queryParams: "id,name,procedureList{id,documentTitle,section,revisionNumber,creationDate}"
      },
      deleteFunction: "deleteProcedureFolder",
      route: "/ihss/ohssystem/procedures/procedure-list"
    },
    {
      name: "inductions",
      functionMutation: "createInductionFolder",
      functionQuery: "inductionFolders",
      folders: [],
      functionQueryItems: {
        name: "inductionFolder",
        queryParams: "id,name,inductionItem{id,creationDate,revisionNumber,documentTitle,section,department,employee,idNumber,contactNumber,complete}"
      },
      deleteFunction: "deleteInductionFolder",
      route: "/ihss/ohssystem/inductions/induction-list"
    },
    {
      name: "meetings",
      functionMutation: "createMeetingFolder",
      functionQuery: "meetingFolders",
      folders: [],
      functionQueryItems: {
        name: "meetingFolder",
        queryParams: "id,name,meetingItem{id,creationDate,meetingDate,location,meetingType,agenda,complete,folderId}"
      },
      deleteFunction: "deleteMeetingFolder",
      route: "/ihss/ohssystem/meetings/meeting-list"
    },
    {
      name: "normalchecklist",
      functionMutation: "createNormalChecklistFolder",
      functionQuery: "normalChecklistFolders",
      folders: [],
      functionQueryItems: {
        name: "checklistFolder",
        queryParams: "id,name,type,checklists{id,type,creationDate,revisionDate,locked,revisionNumber,complex,checklistName,description,section,folderId,questions{question},equipmentList{equipmentId}}"
      },
      deleteFunction: "deleteChecklistFolder",
      route: "/ihss/ohssystem/checklists/checklist-normal"
    },
    {
      name: "multiplechecklist",
      functionMutation: "createComplexChecklistFolder",
      functionQuery: "complexChecklistFolders",
      folders: [],
      functionQueryItems: {
        name: "checklistFolder",
        queryParams: "id,name,type,checklists{id,type,creationDate,revisionDate,locked,revisionNumber,complex,checklistName,description,section,folderId,questions{question},equipmentList{equipmentId}}"
      },
      deleteFunction: "deleteChecklistFolder",
      route: "/ihss/ohssystem/checklists/checklist-multiple"
    },
    {
      name: "vendorchecklist",
      functionMutation: "createContractorChecklistFolder",
      functionQuery: "contractorChecklistFolders",
      folders: [],
      functionQueryItems: {
        name: "checklistFolder",
        queryParams: "id,name,type,checklists{id,type,creationDate,revisionDate,locked,revisionNumber,complex,checklistName,description,section,folderId,questions{question},equipmentList{equipmentId}}"
      },
      deleteFunction: "deleteChecklistFolder",
      route: "/ihss/ohssystem/checklists/checklist-vendor"
    },
    {
      name: "ohsmanagement",
      functionMutation: "createOHSFolder",
      functionQuery: "ohsFolders",
      folders: [],
      functionQueryItems: {
        name: "ohsFolder",
        queryParams: "id,name,ohsReport{id,executiveSummary}"
      },
      deleteFunction: "deleteOHSFolder",
      route: "/ihss/ohssystem/managementreport/management-report-list"
    },
  ]

  constructor(private router: Router, private _graphqlService: GraphqlService, private _http: HttpClient) { }

  setupName(titleName) {
    if (!titleName || titleName == "") {
      titleName = this.router.url.split("/").reverse()[0]
    }
    this.name = titleName
    return titleName
  }

  addToStruct(folderId, folderName) {
    let name = this.name;
    if (name.split(' ').length > 1) {
      name = name.split(' ').join('').toLowerCase();
    }
    let folder = this.folders.find(i => i.name === name).folders
    folder.push({ id: folderId, name: folderName })
  }

  queryFolders(access_token, name) {
    // let name = this.name;
    // if (name.split(' ').length > 1) {
    //   name = name.split(' ').join('').toLowerCase();
    // }
    let functionName = this.folders.find(i => i.name === name).functionQuery
    this.folders.find(i => i.name === name).folders = []
    let graphqlStruct = {
      function: functionName,
      data: {
      },
      returnData: {
        keys: "id, name"
      }
    }

    const customHeaders: HttpHeaders = new HttpHeaders().append('Authorization', access_token);

    let graphqlResponse = this._graphqlService.graphQLQuery(graphqlStruct)

    return this._http.post<any>(this._graphqlService.endpoint, graphqlResponse, { headers: customHeaders })
      .pipe(map((response: IResposne) => {
        return this._graphqlService.formatResponse(response);
      }));
  }

  createFolderGraphQL(folderName, access_token) {
    let name = this.name;
    if (name.split(' ').length > 1) {
      name = name.split(' ').join('').toLowerCase();
    }
    let findFunction = this.folders.find(i => i.name === name).functionMutation
    let folderStruct = {
      function: findFunction,
      data: {
        name: folderName
      },
      returnData: {
        keys: "id, name"
      }
    }

    const customHeaders: HttpHeaders = new HttpHeaders().append('Authorization', access_token);

    let graphqlResponse = this._graphqlService.graphQLMutation(folderStruct);

    return this._http.post<any>(this._graphqlService.endpoint, graphqlResponse, { headers: customHeaders })
      .pipe(map((response: IResposne) => {
        return this._graphqlService.formatResponse(response);
      }));
  }

  queryFoldersItems(access_token, id, folderName) {
    let functionName = this.folders.find(i => i.name === folderName).functionQueryItems
    // this.folders.find(i => i.name === this.name).folders = []
    let graphqlStruct = {
      function: functionName.name,
      data: {
        id: id
      },
      returnData: {
        keys: functionName.queryParams
      }
    }

    const customHeaders: HttpHeaders = new HttpHeaders().append('Authorization', access_token);

    let graphqlResponse = this._graphqlService.graphQLQuery(graphqlStruct)

    return this._http.post<any>(this._graphqlService.endpoint, graphqlResponse, { headers: customHeaders })
      .pipe(map((response: IResposne) => {
        return this._graphqlService.formatResponse(response);
      }));
  }

  deleteSelectedFolder(access_token, name, folder) {
    let functionName = this.folders.find(i => i.name === name)
    // this.folders.find(i => i.name === this.name).folders = []
    let graphqlStruct = {
      function: functionName.deleteFunction,
      data: {
        id: folder.id
      },
      returnData: {
        keys: "id"
      }
    }

    const customHeaders: HttpHeaders = new HttpHeaders().append('Authorization', access_token);

    let graphqlResponse = this._graphqlService.graphQLMutation(graphqlStruct)

    return this._http.post<any>(this._graphqlService.endpoint, graphqlResponse, { headers: customHeaders })
      .pipe(map((response: IResposne) => {
        return this._graphqlService.formatResponse(response);
      }));
  }

}
